import { FC } from 'react';

/**
 * @since 0.1.0
 */
const getWrappedDisplayName = <T, >(wrapperName: string, WrappedComponent: FC<T>) => {
  const wrappedName = getDisplayName<T>(WrappedComponent);

  return `${wrapperName}(${wrappedName})`;
};

function getDisplayName<T>(WrappedComponent: FC<T>) {
  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
}

/**
 * @component
 */
export default getWrappedDisplayName;
